import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/ui/Loader";

export default function KeycloakLogin() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    if (!keycloak.authenticated) {
      keycloak.login({
        redirectUri: window.location.origin + "/admin/dashboard",
      });
      localStorage.clear();
    } else {
      navigate("/admin/dashboard");
    }
  }, [keycloak, navigate]);

  return <Loader />;
}
